import React from "react";

const StepperDash = () => {
  return (
    <div style={{ borderRadius: "10%", width: "20px", height: "6px", background: "#e7e7e7", border: `3px solid #e7e7e7`, marginTop: 12, marginRight: -2 }}/>
  );
};

export default StepperDash;
